import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "../api";
import { profileConfirmed, useAuth } from "../auth/AuthContext";
import { ProfileGatePage } from "../pages/ProfilePage";
import { Btn, globalStyles } from "./Shared";

const CENTERED = { minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center",
                   background: "#f5f5f5", fontFamily: "'DM Sans', sans-serif", padding: 24 };

export default function ProtectedRoute({ children }) {
  const { user, loading, authError, retryAuth } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div style={CENTERED}>
        <div style={{ color: "#6b7280" }}>Loading…</div>
      </div>
    );
  }
  // GET /auth/me failed without a 401: the session may well be fine, so do not send the user to
  // the sign-in page (and do not forget the token); offer to try again.
  if (!user && authError && getToken()) {
    return (
      <div style={CENTERED}>
        <style>{globalStyles}</style>
        <div style={{ maxWidth: 420, width: "100%", background: "#fff", border: "1px solid #e5e7eb", borderRadius: 16,
                      padding: 28, boxShadow: "0 1px 4px rgba(0,0,0,0.06)" }}>
          <h1 style={{ margin: "0 0 12px", fontSize: 20, fontWeight: 700, color: "#1a1a1a" }}>Unio</h1>
          <div role="alert" style={{ padding: "10px 14px", borderRadius: 8, background: "rgba(220,38,38,0.06)",
                                     border: "1px solid rgba(220,38,38,0.25)", color: "#b91c1c", fontSize: 13,
                                     marginBottom: 16 }}>
            Could not reach the server to check your sign-in ({authError.message}). You are still signed in.
          </div>
          <Btn onClick={retryAuth}>Try again</Btn>
        </div>
      </div>
    );
  }
  if (!user) {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?next=${next}`} replace />;
  }
  // A self-registered account (N5) reaches only its own profile until an administrator confirms
  // it; the server answers 403 to everything else. Shown in place of the page asked for (the URL
  // stays), so the page opens by itself once the account is confirmed.
  if (!profileConfirmed(user)) return <ProfileGatePage />;
  return children;
}
